<div class="animated fadeIn backend form-page">
    <div class="row">
        <form id="customerForm" appPromptUnsubmitted (ngSubmit)="save()">
            <div class="row">
                <div class="col-12">
                    <div class="top-header-area">
                        <div class="header-area">
                            <h3>Customer details</h3>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="row">
                        <div class="form-group col-sm-6">
                            <label for="code">Customer ID</label>
                            <input class="form-control"
                                name="code"
                                id="code"
                                type="text"
                                placeholder="(Autogenerated)"
                                [(ngModel)]="customer.code"
                                [disabled]="!!customer.id">
                        </div>

                        <div class="form-group col-sm-6">
                            <label for="name">Name</label>
                            <input class="form-control" id="name" type="text" [(ngModel)]="customer.name" name="name"
                                [appIsInvalid]="!customer.name" required>
                            <div class="invalid-feedback">
                                Name is Required.
                            </div>
                        </div>

                        <div class="form-group col-sm-6">
                            <label for="name">Customer type</label>
                            <select class="form-control custom-select" [(ngModel)]="customer.customerType"
                                name="customerType">
                                <option [ngValue]="1">B2B</option>
                                <option [ngValue]="2">B2C</option>
                            </select>
                        </div>

                        <div class="form-group col-sm-6">
                            <label for="ccmonth">Country</label>
                            <div class="autocomplete">
                                <input name="country" [appIsInvalid]="!customer.country" [(ngModel)]="customer.country"
                                    [typeahead]="countries" [typeaheadMinLength]="0" required id="country"
                                    class="form-control">
                                <div class="invalid-feedback">
                                    Country is Required.
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-sm-12" *ngIf="customer.customerType == customerType.B2B">
                            <label for="name">Logo</label>
                            <app-photo-upload
                                [existingPhotoUrl]="customer.logo?.originalUrl"
                                backgroundSize="contain"
                                [showRemove]="true"
                                (removeImage)="removeLogo()"
                                (photoSelected)="customer.file = $event">
                            </app-photo-upload>
                        </div>
                    </div>
                    <div class="save-button-area">
                        <button type="submit" class="btn btn-primary">Save</button>
                        <button type="button" class="btn btn-outline-dark"
                            [routerLink]="['/admin/customers']">Cancel</button>
                    </div>
                </div>
                <div class="col-xl-6">
                    <h4>Certificates</h4>
                    <table class="table">
                        <thead class="thead-light">
                            <tr>
                                <th>Certificate ID</th>
                                <th>Name of the Planting Site</th>
                                <th class="text-right">Number of tree purchased</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let c of customer.certificates">
                                <td>{{c.code}}</td>
                                <td><a [routerLink]="['/admin', 'plantingSites', c.plantingSiteId, 'general']">{{c.plantingSiteName}}</a></td>
                                <td class="text-right">{{c.count}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </form>
    </div>
</div>

<app-duplicate-name-confirm-modal #confirmDuplicateName></app-duplicate-name-confirm-modal>
